module.exports = __webpack_public_path__ + "img/gleidson_assinatura.21829412.png";